import { Pipe, PipeTransform } from '@angular/core';
import { Table } from '../models';

@Pipe({
    name: 'orderTableName',
    standalone: true,
    pure: true
})
export class OrderTableNamePipe implements PipeTransform {
    transform(table: Table | null | undefined): string {
        if (!table) {
            return '';
        }
        return `${table.area_name} - ${table.name}`;
    }
}
